import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const PaymentTracking: React.FC = () => {
  const features = [
    {
      icon: 'attach_money',
      title: 'Revenue Dashboard',
      description: 'Get a clear overview of your earnings, sales trends, and payout history through an intuitive revenue dashboard.'
    },
    {
      icon: 'receipt',
      title: 'Invoice & Receipt Generation',
      description: 'Automatically generate professional invoices and receipts for all your course sales and subscriptions.'
    },
    {
      icon: 'bar_chart',
      title: 'Detailed Transaction Logs',
      description: 'Access comprehensive logs of all transactions, including successful payments, refunds, and pending payouts.'
    },
    {
      icon: 'analytics',
      title: 'Financial Reporting',
      description: 'Generate customizable financial reports to track your income, expenses, and overall business performance.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-primary-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600/10 via-transparent to-accent-500/10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6">
                Effortless Payment Tracking
                <span className="text-gradient"></span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                Monitor your earnings and manage your finances with our robust payment tracking tools,
                designed for content creators.
              </p>
            </motion.div>

            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex flex-col sm:flex-row gap-4 justify-center mb-12"
            >
              <Link to="/creator/dashboard" className="flex btn-primary text-lg px-8 py-4 items-center justify-center">
                <span className="material-symbols-rounded mr-2">dashboard</span>
                <div className="flex items-center justify-center">Go to Dashboard</div>
              </Link>
              <Link to="/register" className="flex btn-tertiary text-lg px-8 py-4 items-center justify-center">
                <span className="material-symbols-rounded mr-2">person_add</span>
                <div className="flex items-center justify-center">Start Creating</div>
              </Link>
            </motion.div> */}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Advanced Payment Tracking Features
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Gain complete control over your financial performance.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="card-hover text-center group"
              >
                <div className="w-16 h-16 icon-primary flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="material-symbols-rounded text-white text-2xl">{feature.icon}</span>
                </div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 gradient-bg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
              Ready to Optimize Your Finances?
            </h2>
            <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
              Start tracking your payments with ease and grow your content business.
            </p>
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/creator/register" className="flex items-center justify-center glass-button text-lg px-8 py-4">
                <span className="material-symbols-rounded mr-2">rocket_launch</span>
                <div className="flex items-center justify-center">Get Started Free</div>
              </Link>
              <Link to="/contact" className="flex items-center justify-center bg-white/20 backdrop-blur-md border border-white/30 text-white font-medium py-4 px-8 rounded-xl transition-all duration-200 hover:bg-white/30 text-lg">
                <span className="material-symbols-rounded mr-2">support_agent</span>
                <div className="flex items-center justify-center">Contact Support</div>
              </Link>
            </div> */}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PaymentTracking; 